/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Pump_Confirm_CooldownInputs */

const vi_irrigation_pump_confirm_cooldown = /** @type {(inputs: Irrigation_Pump_Confirm_CooldownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sau mỗi lệnh phải chờ đủ 1 phút mới bật lại được, để bảo vệ máy bơm.`)
};

/**

* @param {Irrigation_Pump_Confirm_CooldownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_pump_confirm_cooldown = /** @type {((inputs?: Irrigation_Pump_Confirm_CooldownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Pump_Confirm_CooldownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_pump_confirm_cooldown(inputs)
});